import * as React from 'react';
import { useSelector } from 'react-redux';

import { BuilderContainer } from './Builder';
import { BuildersBlock } from '../../components/BuildersBlock';
import { getBuilders } from '../../selectors/newbuilding';

export function BuildersContainer() {
  const builders = useSelector(getBuilders);

  if (builders.length === 0) {
    return null;
  }

  if (builders.length === 1) {
    return <BuilderContainer builder={builders[0]} />;
  }

  return (
    <BuildersBlock>
      {builders.map(builder => (
        <BuilderContainer key={builder.id} builder={builder} />
      ))}
    </BuildersBlock>
  );
}
